import type { ITagsQueryParams } from '@/modules/tags/infrastructure/dto/ContactTagsDTO';
import type ContactTagsApi from '@/modules/tags/infrastructure/api/ContactTagsClient';

export default class ContactTagService {
  private client: ContactTagsApi;

  constructor(client: ContactTagsApi) {
    this.client = client;
  }

  async fetchTags(params?: ITagsQueryParams) {
    return await this.client.getTags(params);
  }

  async addTagToContact(
    contactId: number,
    agentId: number,
    tagItemId: number[],
  ) {
    return await this.client.addTagToContact(contactId, agentId, tagItemId);
  }

  async addTagToEmployer(
    employerId: number,
    agentId: number,
    tagItemId: number[],
  ) {
    return await this.client.addTagToEmployer(employerId, agentId, tagItemId);
  }

  async deleteTagFromEmployer(
    employerId: number,
    agentId: number,
    tagItemId: number[],
  ) {
    return await this.client.deleteTagFromEmployer(
      employerId,
      agentId,
      tagItemId,
    );
  }

  async deleteTagFromContact(
    contactId: number,
    agentId: number,
    tagItemId: number[],
  ) {
    return await this.client.deleteTagFromContact(
      contactId,
      agentId,
      tagItemId,
    );
  }
}
